'use strict';
if (!customElements.get('mca-digital-consent')) {
  customElements.define('mca-digital-consent', class extends HTMLElement {
    connectedCallback() {
      this.api = window.MCADigitalConsent;
      this.c = this.api.contract(this);
      this.choice = new this.api.Choice();
      this.items = JSON.parse(this.dataset.lines);
      this.choice.update(this.items);
      this.input = this.querySelector('input');
      this.input.checked = false;
      this.busy = false;
      this.status = this.querySelector('[role="status"]');
      this.onSubmit = event => this.checkout(event);
      this.onInput = () => {
        this.choice.choose(this.input.checked, this.items);
        this.status.textContent = '';
        this.render();
        if (!this.input.checked) this.clearRecorded();
      };
      this.input.addEventListener('change', this.onInput);
      document.addEventListener('submit', this.onSubmit, true);
      this.onPageShow = () => { this.choice.choose(false, this.items); this.render(); if (this.api.hasDigital(this.items)) this.clearRecorded(); };
      window.addEventListener('pageshow', this.onPageShow);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
        if (this.busy) return;
        if (event.cartData?.items) this.refresh(event.cartData.items);
        else this.getCart().then(cart => this.refresh(cart.items)).catch(() => this.fail('Your bag could not be checked. Please refresh before checkout.'));
      });
      this.render();
      if (this.api.hasDigital(this.items)) this.clearRecorded();
    }
    disconnectedCallback() {
      document.removeEventListener('submit', this.onSubmit, true);
      window.removeEventListener('pageshow', this.onPageShow);
      this.unsubscribe?.();
    }
    async getCart() {
      const response = await fetch(this.dataset.root + 'cart.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
      if (!response.ok) throw Error('Your bag could not be checked. Please try again.');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw Error('Your bag could not be checked.');
      return cart;
    }
    async changeLine(body) {
      const response = await fetch(this.dataset.root + 'cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(body)});
      if (!response.ok) throw Error('Your digital delivery choice could not be saved. Please try again.');
    }
    render() {
      this.hidden = !this.api.hasDigital(this.items);
      this.input.disabled = this.busy;
      this.input.checked = this.api.hasDigital(this.items) && this.choice.valid(this.items);
      const button = document.querySelector('#checkout');
      if (button) button.disabled = !this.items.length || this.busy || !this.choice.valid(this.items);
      const count = document.querySelector('#mca-bag-count');
      if (count) count.textContent = this.items.reduce((sum, item) => sum + Number(item.quantity), 0);
    }
    fail(message) { this.choice.choose(false, this.items); this.status.textContent = message; this.render(); }
    refresh(items) {
      const changed = this.choice.update(items);
      this.items = items;
      this.render();
      if (changed && this.api.hasDigital(items)) {
        this.status.textContent = 'Your digital bag changed. Please confirm delivery again.';
        this.clearRecorded();
      }
    }
    async clearRecorded() {
      if (this.busy) return;
      this.busy = true; this.render();
      try {
        const cart = await this.api.saveCartConsent({getCart: () => this.getCart(), changeLine: body => this.changeLine(body), c: this.c, choice: this.choice, approved: false});
        this.items = cart.items; this.choice.update(this.items);
        // Clearing properties may merge lines; refresh Dawn's row indices before editing quantities.
        await publish(PUB_SUB_EVENTS.cartUpdate, {source: 'mca-consent', cartData: cart});
      } catch (error) { this.status.textContent = error.message; }
      finally { this.busy = false; this.render(); }
    }
    async checkout(event) {
      if (event.target.id !== 'cart' || event.submitter?.name !== 'checkout' || !this.api.hasDigital(this.items)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (this.busy) return;
      if (document.querySelector('.cart__items--disabled') || [...event.target.querySelectorAll('input[name="updates[]"]')].some(input => input.value !== input.getAttribute('value'))) {
        this.status.textContent = 'Your bag is updating. Please wait, then continue.'; return;
      }
      try { this.choice.require(this.items); } catch (error) { this.fail(error.message); this.input.focus(); return; }
      this.busy = true; this.render(); this.status.textContent = 'Saving your digital delivery choice…';
      try {
        const cart = await this.api.saveCartConsent({getCart: () => this.getCart(), changeLine: body => this.changeLine(body), c: this.c, choice: this.choice, approved: true});
        this.choice.require(cart.items);
        // A property edit can merge lines. Submit the verified current cart, not stale quantity indices.
        const form = document.createElement('form'); form.method = 'post'; form.action = this.dataset.root + 'cart';
        const checkout = document.createElement('input'); checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = 'Checkout'; form.append(checkout);
        const note = document.querySelector('#Cart-note');
        if (note) { const field = document.createElement('input'); field.type = 'hidden'; field.name = 'note'; field.value = note.value; form.append(field); }
        document.body.append(form); HTMLFormElement.prototype.submit.call(form);
      } catch (error) { this.fail(error.message); }
      finally { this.busy = false; this.render(); }
    }
  });
}
